module.exports = __webpack_public_path__ + "static/media/MX.ee70e6a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MX.svg
// module id = 2219
// module chunks = 7